import moment from "moment";
import React from "react";
import { TbChecklist } from "react-icons/tb";
import { TiTick } from "react-icons/ti";
import { TbBikeFilled } from "react-icons/tb";
import { FaMapMarkerAlt } from "react-icons/fa";
import { TbCancel } from "react-icons/tb";
import { FaBoxesPacking } from "react-icons/fa6";
import { GiReceiveMoney } from "react-icons/gi";
import { IoArrowUndoSharp } from "react-icons/io5";


const Tracking = ({ datalist }) => {
  
console.log("ggggg",datalist)
 
  return (
    <div className="w-full">
      <div className="flex gap-5 items-center text-2xl font-semibold text-textColor">
        
        <span>Tracking</span>
      </div>
      <div className="w-full bg-Background1 mt-5 py-1 rounded-3xl">
        {datalist?.map((item, index) => {
          return (
            <div className="w-full bg-Background1 rounded-3xl px-4 flex flex-col justify-between  items-center ">
              <div className="w-full  flex justify-center">
                <div className="h-20 w-1 bg-textColor"></div>
              </div>
              <div className="flex justify-between items-center w-full">
                <div className="w-full flex items-end  flex-1 ">
                  <span className="">{moment(item?.updatedAt).format("DD MMM YYYY hh.mm A")}</span>
                </div>
                <div className="flex flex-col justify-center items-center w-full flex-1">
                  <div className="border-4 border-textColor rounded-full p-4">
                    {item?.status == "accepted" && <TbChecklist className="text-3xl " />}
                    {item?.status == "placed" && <TiTick className="text-3xl"/>}
                    {item?.status == "on_the_way" && <TbBikeFilled />}
                    {item?.status == "dispatch" &&<FaBoxesPacking />}
                    {item?.status == "delivered" && <FaMapMarkerAlt />}
                    {item?.status == "refunded" && <GiReceiveMoney />}
                    {item?.status == "returned" && <IoArrowUndoSharp />}
                    {item?.status == "cancel" && <TbCancel />}
                  </div>
                </div>

                <div className="flex flex-col flex-1">
                  <span className="text-base  lg:text-xl">Order {item?.status}</span>
                  <span className="text-sm ">
                    {item?.notes}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tracking;
